import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select'
import { grupoListarUsuariosPorCompaniaYSucursales, gruposAniadirUsuariosPorGrupo } from '../api/grupos.api';
import { Alert } from "../../../shared/ui";
import { CONST_RUTA_GRUPOS_USUARIOS } from '../../../app/constants/constants-rutas-codigos';
import { obtenerLocalStorage } from '../../../shared/utils/funciones';
import { CONST_KEY_USUARIO_AUTENTICADO, CONST_ROL_MASTER } from '../../../app/constants/constanst-valores';
import { sucursalesPorCompania } from '../../sucursales';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { usuarioObtenerCompaniasYSucursales } from '../../usuarios';

// Se puede usar como modal ANIDADO (props) o como página por ruta (location.state,
// retrocompat). `onClose`/`onSaved` permiten el cierre "por niveles" sin navegar.
export const GrupoUsuariosAgregar = ({
    compania: companiaProp,
    codigo_grupo: codigoProp,
    nombre_grupo: nombreProp,
    onClose,
    onSaved,
}: any = {}) => {

    const [listaCompanias, setListaCompanias] = useState<any[]>([])
    const [listaSucursales, setListaSucursales] = useState<any[]>([])

    const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);
    const rol = usuarioAutenticado?.tipo

    const location = useLocation()

    const nombre_grupo = nombreProp ?? location?.state?.nombre_grupo
    const compania = companiaProp ?? location?.state?.compania

    const codigo_grupo = codigoProp ?? location?.state?.codigo_grupo

    const [mensaje, setMensaje] = useState("")
    const [mostrar, setMostrar] = useState(false)
    const [tipoAlerta, setTipoAlerta] = useState<any>("")

    const [listaUsuarios, setListaUsuarios] = useState<any[]>(/* listaFormateada ||  */[])
    const [selectedUsuarios, setSelectedUsuarios] = useState<any[]>([]);

    const { register, watch, setValue } = useForm<any>({
        defaultValues: {
        }
    });

    const navigate = useNavigate()

    const agregarUsuariosAlGrupo = async () => {
        const selectedListaUsuario = selectedUsuarios.map(option => (
            {
                cod_usuario: option.value,
                estado: "A"
            }
        ));

        const dataPOST = {
            grupo: codigo_grupo,
            compania: compania,
            usuarios: selectedListaUsuario,
            token: usuarioAutenticado?.token
        }

        const { status, message } = await gruposAniadirUsuariosPorGrupo(dataPOST)
        status === 1 ? setTipoAlerta("success") : setTipoAlerta("warning")
        setMostrar(true)
        setMensaje(message)
        // Refresca la lista de usuarios del modal padre (que sigue montado detrás).
        if (status === 1) onSaved?.()
    };

    const cancelar = () => {
        // Modal anidado: cierra solo este nivel (el padre permanece). Fallback a navegar
        // si se usara como página por ruta.
        if (onClose) { onClose(); return }
        navigate(CONST_RUTA_GRUPOS_USUARIOS, {
            state: {
                codigo_grupo,
                compania,
                nombre_grupo
            }
        })
    }

    const obtenerUsuariosSiCambioCompania = async (idCompania) => {

        setSelectedUsuarios([])
        const dataPOST_1 = {
            token: usuarioAutenticado?.token,
            Codigo: idCompania,
            Estado: "A"
        }
        const { sucursales } = await sucursalesPorCompania(dataPOST_1)

        setListaSucursales(sucursales)
        setValue("sucursal", sucursales?.[0]?.CompCod)

        const dataPOST_2 = {
            Compania: watch("compania"),
            Sucursal: watch("sucursal"),
            Grupo: codigo_grupo,
            token: usuarioAutenticado?.token
        }

        const { usuarios } = await grupoListarUsuariosPorCompaniaYSucursales(dataPOST_2)

        const listaFormateadaUsuarios = usuarios?.map(u => (
            {
                value: u?.codigo,
                label: u?.nombre
            }
        ))

        setListaUsuarios(listaFormateadaUsuarios)

    }

    const obtenerUsuariosSiCambioSucursal = async (idSucursal) => {

        setSelectedUsuarios([])
        const dataPOST = {
            Compania: watch("compania"),
            Sucursal: idSucursal,
            Grupo: codigo_grupo,
            token: usuarioAutenticado?.token
        }

        const { usuarios } = await grupoListarUsuariosPorCompaniaYSucursales(dataPOST)

        const listaFormateadaUsuarios = usuarios?.map(u => (
            {
                value: u?.codigo,
                label: u?.nombre
            }
        ))

        setListaUsuarios(listaFormateadaUsuarios)
    }

    const obtenerCompaniasYSucursales = async (token?: any) => {

        const dataPOST = {
          token: usuarioAutenticado?.token
        }

        const { companias, sucursales } = await usuarioObtenerCompaniasYSucursales(dataPOST)

        setListaCompanias(companias)
        setListaSucursales(sucursales)

        setValue("compania", compania)

        return {
          sucursales
        }
      }

      const obtenerSucursalesPorCompaniaPorDefecto = async (idCompania) => {

        if (idCompania && String(idCompania) !== "T") {
          const dataPOST = {
            token: usuarioAutenticado?.token,
            Codigo: idCompania,
            Estado: "A"
          }
          const { sucursales } = await sucursalesPorCompania(dataPOST)
          setListaSucursales(sucursales)
          setValue("sucursal", watch("sucursal") === "" ? sucursales?.[0]?.CompCod : watch("sucursal"))
        }
      }


      useEffect(() => {

        const cargarDatosIniciales = async () => {
          const {sucursales} = await obtenerCompaniasYSucursales(usuarioAutenticado?.token)
          if (rol === CONST_ROL_MASTER) {
            await obtenerSucursalesPorCompaniaPorDefecto(compania);
          } else {
            const listaSucursalesFormateada = sucursales?.map(s => ({
              CompCod: s?.id,
              CompNom: s?.tipo
            }))
            setListaSucursales(listaSucursalesFormateada)
            setValue("sucursal", listaSucursalesFormateada?.[0]?.CompCod)
          }

          await obtenerUsuariosSiCambioSucursal(watch("sucursal"));
        };

        cargarDatosIniciales();

        // carga inicial (una sola vez al montar)
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])


    return (
        <div className="p-3">
            <div className="container-fluid">
                <h4 className="text-center mt-1">Añadir Usuarios al grupo: {nombre_grupo}</h4>
                <div className="row mt-4">
                    <div className="col-12 col-lg-8 mx-auto mt-0 tw-rounded-2xl tw-bg-white tw-shadow-md tw-border tw-border-gray-100 p-3">
                        {/* Formulario */}
                        <form className="row g-2 p-1">

                            <div className="col-12 col-lg-6">
                                <label className="text-start">Compañía</label>
                                <select
                                    {...register("compania", {
                                        onChange: async (e) => {
                                            await obtenerUsuariosSiCambioCompania(e.target.value)
                                        }
                                    })}
                                    className="form-select form-select-sm"
                                    value={watch("compania")}
                                    disabled={true}
                                >
                                    {
                                        listaCompanias?.length > 0 && listaCompanias.map(e => (
                                            <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-12 col-lg-6">
                                <label className="text-start">Sucursal</label>
                                <select
                                    {...register("sucursal", {
                                        onChange: async (e) => {
                                            await obtenerUsuariosSiCambioSucursal(e.target.value)
                                        }
                                    })}
                                    className="form-select form-select-sm"
                                    value={watch("sucursal")}

                                >

                                    {
                                        listaSucursales?.length > 0 && listaSucursales.map(e => (
                                            <option key={e?.CompCod} value={e?.CompCod}>{e?.CompNom}</option>
                                        ))
                                    }
                                    {/* <option value={"T"}>TODOS</option> */}
                                </select>
                            </div>

                            <div className="col-12 col-lg-12">

                                    <label className="text-start">Ingrese usuario(s)</label>
                                    <div>
                                        <Select
                                            isMulti
                                            name="colors"
                                            options={listaUsuarios}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={selectedUsuarios}
                                            onChange={setSelectedUsuarios as any}
                                        />
                                    </div>

                            </div>
                        </form>
                        {/* Fin formulario */}
                    </div >

                </div>

                <div className='mt-4 botones-accion text-center'>
                    <button className='btn btn-sm btn-primario col-md-2' onClick={agregarUsuariosAlGrupo}>Guardar</button>
                    <button className='btn btn-sm btn-secundario col-md-2' onClick={cancelar}>Cancelar</button>
                </div>


                {
                    mostrar && (
                        <div className="row mt-4">
                            <div className="col-lg-6 mx-auto text-center alert-error">
                                <Alert severity={tipoAlerta}>{mensaje}</Alert>
                            </div>
                        </div>

                    )
                }

            </div>
        </div>
    )
}
